<template>
  <div class="layout--full-page auth-wrapper auth-v1 px-2 bg-img" style="overflow-y:auto;">
    <div class="auth-inner py-2" style="max-width: 60%;">

      <!-- Login v1 -->
      <div>
        <b-card class="mb-0">
          <div class="">
            <div style="text-align: center;" class="mb-2">
                <img class="logo d-none d-lg-inline" :src="require('@/assets/images/logo/logo-signathor.webp')" alt="Logo" loading="lazy">
                <img class="logo-sm d-lg-none" :src="require('@/assets/images/logo/signathor_transparent.webp')" alt="Logo" loading="lazy">
            </div>
            <b-row
              class="no-gutter d-flex align-items-center"
            >

              <b-col
                class="d-none d-lg-block"
                lg="6"
              >
                <img :src="require('@/assets/images/pages/login.webp')" alt="login" style="margin: 0px 5px; width: 400px;" fetchpriority="high">
              </b-col>


              <b-col
                class=""
                xs="12"
                sm="12"
                md="12"
                lg="6"
              >
                <div class="p-8 login-tabs-container">
                  <b-alert v-if="token_publico" variant="danger" show>
                    <div class="alert-body">
                      <feather-icon
                        icon="InfoIcon"
                        class="mr-50"
                      />
                      La ruta consultada no existe.
                    </div>
                  </b-alert>
                  <loginTemplate></loginTemplate>
                </div>
              </b-col>

            </b-row>
          </div>
        </b-card>
      </div>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import LoginTemplate from './LoginTemplate.vue'
export default{
  data(){
    return {
      allowLogin: false,
      token_publico: this.$route.params.token_publico
    }
  },
  head: {
    link: [
      {
        rel: 'preload',
        href: require('@/assets/images/pages/login.webp'),
        as: 'image',
        type: "image/webp",
        //fetchpriority: "high"
      },
      {
        rel: 'preload',
        href: require('@/assets/images/logo/logo-signathor.webp'),
        as: 'image',
        type: "image/webp",
        //fetchpriority: "high"
      },
      {
        rel: 'preload',
        href: require('@/assets/images/logo/signathor_transparent.webp'),
        as: 'image',
        type: "image/webp",
        //fetchpriority: "high"
      }
    ]
  },
  components: {
    LoginTemplate,
  },
  created() {
    if(this.$cookie.get('usuario') != null){
      if(this.$route.query != null && this.$route.query.plan != undefined){
        this.$router.push("/plan/checkout/"+String(this.$route.query.plan) + "/")
      }else{
        this.$router.push("/")
      }
    }else{
      this.allowLogin = true;
      // redirigir a login sin subdominio
      // Obtener la URL actual
      const currentURL = window.location.href;

      // Crear un objeto URL para manipular la URL actual
      const url = new URL(currentURL);

      // Separar el hostname en partes
      const hostnameParts = url.hostname.split('.');

      // Verificar que hay un subdominio (mínimo 3 partes: subdominio, dominio, TLD)
      if (hostnameParts.length > 2) {
          // Eliminar el subdominio
          const newHostname = hostnameParts.slice(1).join('.');

          // Crear la nueva URL sin el subdominio
          const newURL = `${url.protocol}//${newHostname}${url.pathname}${url.search}`;

          // Redirigir a la nueva URL sin el subdominio
          window.location.replace(newURL);
      }
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

    .logo{
        height: 60px;
        width: 18rem;
    }
    .logo-sm{
        height: 100px;
    }
</style>
